import axiosBase from "@/api/axiosBase";
import { Inp } from 'iws'

const state = {
    sceneInfo: {}, //存放编辑的案例信息
    sceneInp: {},   //存放wasm的解析inp
    currentActiveSceneId:'',
    airSites:{}, //存放气象站点
    airSiteChangeNum: -1,
    psSites:{}, //存放点源站点
    psSiteChangeNum: -1,
    hdcsSites:{}, //存放河道抽水
    hdcsSiteChangeNum:-1,
    isHasPS:{},  //是否有点源
    isHasHDCS:{},  //是否有河道抽水
    isShowXiaDianMian: {},
    sceneFileInfo:{}, //存放案例文件信息

    sceneStatus:{},
    sceneStatusChangeNum:-1,

    canEdit:{},  //是否可编辑

    simplyFeatures: {}
}

const getters = {
    airSiteChange:state=>state.airSiteChangeNum,
    psSiteChange: state=>state.psSiteChangeNum,
    hdcsSiteChange: state=>state.hdcsSiteChangeNum,
    sceneStatusChange: state => state.sceneStatusChangeNum
}

const actions = {
    //获取模型基础信息
    //根据modelId查询模型
    getModelInfoById({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'GET',
                url:'/model/base/' + data.sceneId
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                else{
                    commit('setSceneInfo', res.data.data);
                    console.log(res.data.data)
                    let inp = Inp.from_b85z(res.data.data.inp);
                    commit('setInpDetails', {'sceneId':data.sceneId, 'inp':inp});
                    sessionStorage.setItem('sceneInp',  {'sceneId':data.sceneId, 'inp':inp});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //获取文件信息(子流域、子河道、HRU 重分类后：土壤、土地利用、坡度)
    getFileInfo({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'GET',
                url:'/basedata/filebase/qb/' + data.sceneId
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                else{
                    commit('setSceneFileInfo', {'sceneId': data.sceneId, 'fileInfo':res.data.data});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //修改模型信息
    updateSceneInfo({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/base/updateModel',
                data:{
                    "model_id": data.sceneId,
                    "model_name": data.name,
                    "inp": data.inp,
                    "is_star": data.star,
                    "is_template": data.template,
                    "remark": data.remark,
                    "status":data.status,

                    "build_type": null,
                    "template_id": null
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    
    //获取模型外部数据-数据值
    //type = decay, sId = 1,获取为边界条件，点源冲刷数据， sid = 2, 获取为初始条件-冷启动-水质模拟-点源
    //边界条件用这个接口，初始条件有另外的接口
    getSiteValue({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/extdata/get_value',
                data:{
                    "model_id": data.sceneId,
                    "data_type": data.type, 
                    "data_id": data.sId  
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //模型外部数据-获取所有的元数据
    getExtData({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/extdata/list_meta',
                data:{
                    "model_id": data.sceneId,
                    "data_type": data.type
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //删除站点
    deleteExtSite({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/extdata/delete',
                data:{
                    "model_id": data.sceneId,
                    "data_type": data.type,
                    'data_ids':data.data_ids
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //获取气象数据自定义处理
    getAirCustomBuild({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/metero/custom_build',
                data:{
                    "model_id": data.sceneId,
                    "sdate": data.st,  //YYYY-MM-DD
                    "edate": data.et,  //YYYY-MM-DD
                    "file_ids": data.fileIds,
                    "replace": data.replace
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //获取气象替换站
    getReplaceSites({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/metero/get_replace',
                data:{
                    "model_id": data.sceneId,
                    "sdate": data.st,
                    "edate": data.et,
                    "file_ids": data.fileIds
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //更新气象相关信息
    updateAirInfo({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/metero/subbasin_air_weight',
                data:{
                    "model_id": data.sceneId
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //获取点源文件指标
    getPtFilePoll({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/boundary/vars',
                data:{
                    "make_type": data.makeType,
                    "file_ids": data.fileIds
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //获取点源基础信息
    getPtBaseInfos({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/boundary/info',
                data:{
                    "model_id": data.sceneId,
                    "make_type": data.makeType,
                    "file_ids": data.fileIds,
                    "sdate": data.sdate,
                    "edate": data.edate,
                    "calc_vars": data.modelPolls,
                    "orig_vars": data.filePolls,
                    "cast_coeff": data.xs,
                    "edb": data.edb
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //构建点源-从基础数据添加
    buildPS({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/boundary/build',
                data:{
                    "model_id": data.sceneId,
                    "make_type": data.make_type,
                    "value": data.value
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //直接地图添加点源
    addPS({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/boundary/direct/ptsrc',
                data:{
                    "model_id": data.sceneId,
                    "lat": data.lat,
                    "lon": data.lon,
                    "name": data.name,
                    "ps_type": data.ps_type,
                    "rch_id": data.rch_id,
                    "unit_type": data.unit_type,
                    "datetime": data.datetime,
                    "ptsrc_data": data.ptsrc_data
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //更新点源河道冲刷
    //data_id = 1,获取为边界条件，点源冲刷数据， data_id = 2, 获取为初始条件-冷启动-水质模拟-点源
    //边界条件用这个接口，初始条件有另外的接口
    setPSDecay({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/boundary/decay',
                data:{
                    "model_id": data.sceneId,
                    'data_id':data.data_id,   //1 decay, 2-restorage
                    "value": data.decayDatas
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //删除点源时，同时调用删除点源冲
    deletePSDecay({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/boundary/delete/decay',
                data:{
                    "model_id": data.sceneId,
                    "pid": data.pid
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    deleteAllPS({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'GET',
                url:'/model/boundary/clear/'+data.sceneId
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //获取默认入河系数时间模式
    getDefaultPSPattern({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/boundary/pattern/default',
                data:{
                    "model_id": data.sceneId,
                    "make_type": data.make_type,
                    "pattern_type": data.pattern_type
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //创建入河系数时间模式
    addNewPSPattern({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/boundary/pattern',
                data:{
                    "model_id": data.sceneId,
                    'make_type': data.make_type,
                    "name": data.name,
                    "pattern_type": data.pattern_type,
                    "value": data.value
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //检查入河系数时间模式名称
    checkPSPatternName({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/boundary/pattern/check',
                data:{
                    "model_id": data.sceneId,
                    "name": data.name
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //删除入河系数时间模式
    deletePSPattern({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/boundary/pattern/delete',
                data:{
                    "model_id": data.sceneId,
                    "pattern_ids": data.pattern_ids
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //获取模型使用的时间模式
    getSceneUsePattern({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'GET',
                url:'/model/boundary/pattern/' + data.sceneId
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //获取河道抽水基础信息
    getHDCSBaseInfo({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/boundary/info/withdraw',
                data:{
                    "model_id": data.sceneId,
                    "file_ids": data.fileIds
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //构建河道抽水-从基础数据添加
    buildHDCS({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/boundary/build/withdraw',
                data:{
                    "model_id": data.sceneId,
                    "value": data.tableValue,
                    'sdate':data.sdate,
                    'edate':data.edate
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //直接地图添加河道抽水
    addHDCS({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/boundary/direct/withdraw',
                data:{
                    "model_id": data.sceneId,
                    "lat": data.lat,
                    "lon": data.lon,
                    "lat1": data.lat1,
                    "lon1": data.lon1,
                    "name": data.name,
                    "target_id": data.target_id,
                    "rch_id": data.rch_id,
                    "draw_type": data.draw_type,
                    "datetime": data.datetime,
                    "withdraw": data.withdraw
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //根据经纬度获取子河道ID
    getRCHIDbyCoordinate({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/boundary/rch',
                data:{
                    "model_id": data.sceneId,
                    "lat": data.lat,
                    "lon": data.lon
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //保存修改灌溉时序/累积冲刷
    updateIrrigOrAccum({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/setting/save',
                data:{
                    "model_id": data.sceneId,
                    "data_type": data.data_type,
                    "value_vec": [
                        {
                            "id": data.id,
                            "name": data.name,
                            "notes": data.notes,
                            "value": data.value
                        }
                    ]
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //修改名称、类型、备注等
    //"list": [
    //     {
    //         "data_id": 0,
                // "elev": 0,
                // "name": "string",
                // "notes": "string",
                // "ps_group": "string",
                // "rch_id": 0,
                // "stype": "string"
    //     }
    // ],
    updateBoundarySite({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/extdata/update',
                data:{
                    "model_id": data.sceneId,
                    "data_type": data.data_type,
                    "list": data.list
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //设置气象条件云端复制
    setAirCloudCopy({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/metero/from_model',
                data:{
                    "model_id": data.sceneId,
                    "model_id_from": data.fromSceneId,
                    "sdate": data.st,
                    "edate": data.et,
                    "clear_old": data.clear_old
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //设置点源和河道抽水云端复制
    setPSAndHDCSCloudCopy({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/boundary/clone/ptsrcOrWithdraw',
                data:{
                    "model_id": data.sceneId,
                    "model_id_from": data.fromSceneId,
                    "clear_old": data.clear_old,
                    "clone_type": data.clone_type
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },

    //热启动
    getHotStartInfos({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'GET',
                url:'/model/restart/list?project_id='+data.project_id+'&group_id='+data.group_id
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //设置模型热启动信息
    setModelHotStart({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/restart/set?model_id='+data.sceneId + '&restart_model_id='+data.restart_model_id+'&restart_id='+data.restart_id
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //获取热启动文件模块列表
    getModelHotSections({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'GET',
                url:'/model/restart/list_section?model_id='+data.sceneId
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //获取热启动模块信息
    getHotSectionInfo({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'GET',
                url:'/model/restart/get_section?model_id='+data.sceneId+'&section_name='+data.section_name
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //设置热启动模块信息
    setHotSectionInfo({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/restart/set_section',
                data:{
                    "model_id": data.sceneId,
                    "section_data": data.section_data,
                    "section_name": data.section_name
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //获取冷启动点源列表
    getColdPS({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'GET',
                url:'/model/coldstart/get_init_ptsrc?model_id='+data.sceneId
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //设置冷启动点源列表
    setColdPS({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/coldstart/set_init_ptsrc',
                data:{
                    "data": data.data,
                    "model_id": data.sceneId
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    
    //获取模型数据配置
    getSceneConfig({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'GET',
                url:'/model/base/conf/' + data.sceneId
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //设置模型数据配置
    setSceneConfig({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/base/saveconf',
                data:{
                    "model_id": data.sceneId,
                    "bound_weather_ids": data.bound_weather_ids,
                    "hru_dem_id": data.hru_dem_id,
                    "hru_landuse_id": data.hru_landuse_id,
                    "hru_soil_id": data.hru_soil_id,
                    "sub_dem_id": data.sub_dem_id,
                    "sub_hdgq_id": data.sub_hdgq_id
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },

    //上传灌溉时序等
    updateSettingFile({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            let formData=new FormData();
            formData.append('file',data.file);
            formData.append('filename',data.file.name)
            axiosBase({
                method:'POST',
                url:'/model/setting/upload?model_id=' + data.model_id + '&data_type=' + data.data_type + '&calc_vars=' + data.calc_vars + '&file_size=' + data.file.size + '&start_time=' + data.start_time + '&end_time=' + data.end_time,
                data:formData
            })
            .then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}});
            })
        })
    },

    //更新用户输出指标
    updateCustomOutputZB({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/ctrl/custom_output',
                data: {
                    "model_id": data.sceneId,
                    "formulas": data.formulas,
                    "quals": data.quals
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },

    //获取子流域子河道中心点
    getSceneFeatureCenter({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'GET',
                url:'/basedata/gis/center_point/' + data.sceneId
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },

    // 获取模型延长数据的时间范围
    getModelExtendTimeSeriesList({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/extend/time_ranges',
                data:{
                    "model_id": data.sceneId
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //匹配气象延长文件
    matchAir({dispath, commit},data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/extend/metero/match',
                data:{
                    "model_id": data.model_id,
                    "file_ids": data.file_ids
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //构建气象延长数据
    buildExtendModelAir({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/extend/metero/build',
                data:{
                    "model_id": data.model_id,
                    "sdate": data.sdate,
                    "edate": data.edate,
                    "file_mapping": data.file_mapping
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //匹配点源延长文件
    //要匹配的点源制作类型：模型导入、直接添加、导入畜禽数据制作、导入人口数据制作、导入污染源数据制作；模型导入时匹配全部点源
    matchPS({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/extend/ptsrc/match',
                data:{
                    "model_id": data.model_id,
                    "file_ids": data.file_ids,
                    "make_type": data.make_type
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //获取点源变量映射配置
    getPSVariableMapping({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/extend/ptsrc/vars',
                data:{
                    "model_id": data.model_id,
                    "file_mapping": data.file_mapping
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //构建点源延长数据
    /*
     "items": [
        {
            "data_id": 0,
            "extend_file_id": 0,
            "original_file_id": 0,
            "point_name": "string",
            "point_type": "string",
            "rch_id": 0,
            "variables": [
                {
                    "calc_var": "string",
                    "cast_coeff": 0,
                    "rch_coeff": 0,
                    "source_var": "string"
                }
            ]
        }
    ],
     */
    buildExtendModelPS({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/extend/ptsrc/build',
                data:{
                    "model_id": data.model_id,
                    "items": data.items
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //获取人口或畜禽点源的指标映射默认值。
    getJingjiVars({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/extend/ptsrc/socio/vars',
                data:{
                    "file_id": data.file_id,
                    "original_file_id": data.original_file_id,
                    "make_type": data.make_type,
                    "model_id": data.model_id
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //预览人口或畜禽延长文件、推荐映射和系数确认表。
    getJingjiPreview({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/extend/ptsrc/socio/preview',
                data:{
                    "file_id": data.file_id,
                    "original_file_id": data.original_file_id,
                    "make_type": data.make_type,
                    "model_id": data.model_id
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //批量制作人口或畜禽点源延长数据。
    /*
    variables array[object (PtsrcVarConfig)] 必需 模拟指标、原始指标及转换系数。

    calc_var string 必需 模型内需要计算的指标名称

    cast_coeff number <double> | null  可选 原始指标转换为模型指标的单位转换系数

    rch_coeff number <double> | null 指标进入河道的系数 可选
    source_var string  | null 可选 延长文件中映射到该计算指标的原始指标名称
     */
    buildExtendModelJingji({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/extend/ptsrc/socio/build',
                data:{
                    "model_id": data.model_id,
                    "file_id": data.file_id,
                    "original_file_id": data.original_file_id,
                    "sdate": data.sdate,
                    "edate": data.edate,
                    "make_type": data.make_type,
                    "value": data.value,
                    "variables": data.variables
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //复制并延长年度或自定义入河系数时间模式。
    extendModelRchCoefficient({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/extend/ptsrc/pattern/extend',
                data:{
                    "model_id": data.model_id,
                    "pattern_id": data.pattern_id,
                    "value": data.value
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //查询可手动延长的直接添加点源。
    queryManualExtendablePoints({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/extend/ptsrc/manual/list',
                data:{
                    "model_id": data.model_id
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //批量手动延长直接添加点源。
    /**
     "items": [
        {
            "data_id": 0,
            "datetime": [
                "string"
            ],
            "values": {}
        }
    ],items
array[object (ManualPtsrcItem)]
必需
本次选择并提交的点源延长数据。

data_id
integer <int32>
必需
模型内点源数据ID。

>= 0
datetime
array[string]
必需
延长数据的时间序列。

values
object
必需
     */
    extendModelManualPoints({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/extend/ptsrc/manual/build',
                data:{
                    "model_id": data.model_id,
                    "sdate": data.sdate,
                    "edate": data.edate,
                    "items": data.items
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //匹配河道抽水延长文件。
    matchManualWithdraw({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/extend/withdraw/match',
                data:{
                    "model_id": data.model_id,
                    "file_ids": data.file_ids
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //构建河道抽水导入延长数据。
    buildExtendModelWithdraw({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/extend/withdraw/build',
                data:{
                    "model_id": data.model_id,
                    "file_mapping": data.file_mapping
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //查询可手动延长的河道抽水数据。
    extendModelManualWithdraw({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/extend/withdraw/manual/list',
                data:{
                    "model_id": data.model_id
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //批量手动延长河道抽水数据。
    /*
        "items": [
        {
            "data_id": 0,
            "datetime": [
                "string"
            ],
            "withdraw": [
                0
            ]
        }
    ],
    items
array[object (ManualWithdrawItem)]
必需
本次选择并提交的抽水延长数据。

data_id
integer <int32>
必需
模型内抽水数据ID。

>= 0
datetime
array[string]
延长时间序列。
必需
withdraw
array[number <double>]
抽水比例或流量。
必需
    */
    extendModelManualWithdrawBatch({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/extend/withdraw/manual/build',
                data:{
                    "model_id": data.model_id,
                    "items": data.items
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //查询累积冲刷已上传的延长文件token。
    getAccumExtendToken({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/extend/accum/upload_tokens',
                data:{
                    "model_id": data.model_id
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //上传累积冲刷延长数据并返回token。
    uploadAccumExtendData({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            let formData = new FormData();
            formData.append('file', data.file);
            formData.append('filename', data.file.name);
            axiosBase({
                method:'POST',
                url:'/model/extend/accum/upload?model_id=' + data.model_id + '&file_size=' + (data.file_size || data.file.size),
                data: formData
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //构建累积冲刷延长数据。
    /*
    "items": [
        {
            "data_id": 0,
            "extend_name": "string",
            "upload_token": "string"
        }
    ]
        items
array[object (SeriesExtendBuildItem)]
必需
本次选择延长的时序。

data_id
integer <int32>
必需
模型内时序数据ID。

>= 0
extend_name
string  |
null
可选
上传文件中的时序名称；为空时使用原时序名称。

upload_token
string
必需
上传接口返回的上传令牌。
    */
    buildAccumExtendData({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/extend/accum/build',
                data:{
                    "model_id": data.model_id,
                    'items': data.items
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //查询灌溉时序已上传的延长文件token。
    queryIrrigExtendToken({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/extend/irrig/upload_tokens',
                data:{
                    "model_id": data.model_id
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //上传灌溉时序延长数据并返回token。
    uploadIrrigExtendData({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            let formData = new FormData();
            formData.append('file', data.file);
            formData.append('filename', data.file.name);
            axiosBase({
                method:'POST',
                url:'/model/extend/irrig/upload?model_id=' + data.model_id+'&file_size='+(data.file_size || data.file.size),
                data: formData
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    },
    //构建灌溉时序延长数据。
    /*
     "items": [
        {
            "data_id": 0,
            "extend_name": "string",
            "upload_token": "string"
        }
    ],
    items
array[object (SeriesExtendBuildItem)]
必需
本次选择延长的时序。

data_id
integer <int32>
必需
模型内时序数据ID。

>= 0
extend_name
string  |
null
可选
上传文件中的时序名称；为空时使用原时序名称。

upload_token
string
必需
上传接口返回的上传令牌。
     */
    buildIrrigExtendData({dispatch, commit}, data){
        return new Promise((resolve,reject)=>{
            axiosBase({
                method:'POST',
                url:'/model/extend/irrig/build',
                data:{
                    "model_id": data.model_id,
                    'items': data.items
                }
            }).then(res=>{
                if(res.data.code != 200){
                    commit('message/setMessage', {'type':'error', 'message':res.data.msg}, {root:true});
                }
                resolve(res)
            })
            .catch(error=>{
                commit('message/setMessage', {'type':'error', 'message':error}, {root:true});
                resolve({data:{code:500}})
            })
        })
    }
}

const mutations = {
    setSceneInfo(state, sceneInfo){
        state.sceneInfo[sceneInfo.id] = sceneInfo;
    },
    //案例inp
    setInpDetails(state, jsonStr){
        state.sceneInp[jsonStr.sceneId] = jsonStr.inp;
    },
    //设置当前案例id
    setCurrentSceneId(state, sceneId){
        state.currentActiveSceneId = sceneId;
    },
    //设置案例的气象站点
    setSceneSites(state, jsonStr){
        if(jsonStr.type == '气象'){
            state.airSites[jsonStr.sceneId] = jsonStr.sites;
            state.airSiteChangeNum++;
        }
        else if(jsonStr.type == '点源'){
            state.psSites[jsonStr.sceneId] = jsonStr.sites;
            if(jsonStr.sites.length > 0){
                state.isHasPS[jsonStr.sceneId] = true;
            }
            else{
                state.isHasPS[jsonStr.sceneId] = false;
            }
            state.psSiteChangeNum++;
        }
        else if(jsonStr.type == '河道抽水'){
            state.hdcsSites[jsonStr.sceneId] = jsonStr.sites;
            if(jsonStr.sites.length > 0){
                state.isHasHDCS[jsonStr.sceneId] = true;
            }
            else{
                state.isHasHDCS[jsonStr.sceneId] = false;
            }
            state.hdcsSiteChangeNum++;
        }
    },
    setScenePSandHDCS(state, jsonStr){
        state.isHasPS[jsonStr.sceneId] = jsonStr.isHasPS;
        state.isHasHDCS[jsonStr.sceneId] = jsonStr.isHasHDCS;
    },
    //设置下垫面
    setXiaDianMian(state, jsonStr){
        state.isShowXiaDianMian[jsonStr.sceneId] = jsonStr.isShow;
    },
    setSceneStatus(state, jsonStr){
        state.sceneStatus[jsonStr.sceneId] = jsonStr.status;
        state.sceneStatusChangeNum++;
    },
    setSceneFileInfo(state, jsonStr){
        state.sceneFileInfo[jsonStr.sceneId] = jsonStr.fileInfo;
    },
    setSceneCanEdit(state, jsonStr){
        state.canEdit[jsonStr.sceneId] = jsonStr.canEdit;
    },
    setSymplyFeatures(state, jsonStr){
        state.simplyFeatures[jsonStr.layerId] = jsonStr.features;
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
